import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/news/chongzhi.png'
import _imports_1 from '@/assets/news/delay_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-7faa9662"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "detail-loading"
}
const _hoisted_2 = {
  key: 1,
  class: "detail-content-wrap"
}
const _hoisted_3 = { class: "detail-font-bar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "detail-font-icon",
  alt: ""
}, null, -1))
const _hoisted_5 = { class: "detail-font-label" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "detail-meta" }
const _hoisted_8 = { class: "detail-meta__label" }
const _hoisted_9 = { class: "detail-source" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "detail-time" }
const _hoisted_12 = {
  key: 0,
  class: "audio-inline"
}
const _hoisted_13 = { class: "audio-inline__duration" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 5v14l11-7z" })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["max", "value"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 4h4v16H6V4zm8 0h4v16h-4V4z" })
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 0,
  class: "detail-stocks"
}
const _hoisted_21 = ["onDblclick"]
const _hoisted_22 = { class: "stock-card__name" }
const _hoisted_23 = { class: "stock-card__name-text" }
const _hoisted_24 = {
  key: 0,
  src: _imports_1,
  class: "stock-card__delay-icon",
  alt: "延时"
}
const _hoisted_25 = {
  key: 1,
  class: "detail-video"
}
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "detail-body-wrap" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = {
  key: 3,
  class: "detail-permission-mask"
}
const _hoisted_30 = { class: "detail-permission-content" }
const _hoisted_31 = { class: "detail-permission-line1" }
const _hoisted_32 = { class: "detail-permission-line3" }
const _hoisted_33 = {
  key: 0,
  class: "news-advert-banner"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  key: 0,
  class: "news-advert-dots"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 2,
  class: "detail-placeholder"
}
const _hoisted_39 = {
  key: 3,
  class: "detail-risk-tip"
}
const _hoisted_40 = { class: "hs-modal" }
const _hoisted_41 = { class: "hs-modal__header" }
const _hoisted_42 = { class: "hs-modal__title" }
const _hoisted_43 = { class: "hs-modal__text" }
const _hoisted_44 = { class: "hs-modal__footer" }

import { ref, watch, computed, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import infoApi from '@/api/info'
import { objTran } from '@/utils/lang.js'
import type { RecommendItem } from './RecommendList.vue'
import RecommendList from './RecommendList.vue'
import { jumpToStockChart, getStockClass } from '@/utils/stock'
import {
  openNewsWindow,
  resolveAdvertJumpLink,
  getAdvertPopupFrequency,
  reportAdvertClick,
  reportAdvertExposure,
} from '@/utils/news'
import ws from '@/websocket/index'
import { resolveMarket ,getFDMarketRegion} from '@/websocket/quotationWebsocket'

// ─── Props ────────────────────────────────────────────────────────────────────
interface StockItem {
  id: number
  symbol: string
  name: string | null
  fluctuation_range: number
  exchange: string | null
  market: string | null
  lastPrice: number | null
  isSelfSelected: number | null
  stock_list_status: string
  stock_list_status_name: string
  newsId: number
}

interface DetailData {
  id: number
  title: string
  abstracts: string
  content: string
  sourceName: string
  category: string       // 文章来源名称
  avatar: string         // 来源头像图片链接
  createTime: string
  publishTime: string
  audioUrl: string
  videoUrl: string
  stock: StockItem[]
  dataType: string
  isPermission: number   // 0-无权限 1-有权限
  pathInfo: { pdfUrl?: string; pdfName?: string; readUrl?: string }
  [key: string]: any
}

interface AdvertMaterialInfo {
  guideContent?: string      // 后台配置的跳转内容（解析后为 gw:// 协议链接）
  pcJumpLink?: string        // 跳转链接
  simpleBlack?: string       // 简体黑色主题图片
  simpleWhite?: string       // 简体白色主题图片
  tradBlack?: string         // 繁体黑色主题图片
  tradWhite?: string         // 繁体白色主题图片
  [key: string]: any
}

interface AdvertItem {
  adCode?: string
  adcode?: string
  sourceId?: string
  dailyFreguency?: string | number
  dailyFrequency?: string | number
  frequencyType?: string | number
  adTitle?: string
  materialInfos?: AdvertMaterialInfo[]
  [key: string]: any
}

/** 展平后的轮播项，每条 materialInfo 对应一个轮播 */
interface AdvertSlide {
  img: string
  link: string
  adCode: string
  sourceId: string
  popupFrequency: string | number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsDetail',
  props: {
    isDark: { type: Boolean },
    newsId: null,
    newsDecryptId: null,
    createTimeFormat: null,
    hideRecommend: { type: Boolean },
    hasListData: { type: Boolean },
    listLoading: { type: Boolean }
  },
  emits: ["select-news"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'select-news', id: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isDark: boolean
  /** 当前选中的文章 id，用于推荐资讯接口 */
  newsId: number | string | null
  /** 文章 decryptId，用于文章详情接口；未传时降级使用 newsId */
  newsDecryptId?: string | null
  /** 列表侧传入的格式化时间，优先展示 */
  createTimeFormat?: string
  /** 隐藏底部推荐资讯（独立详情页使用） */
  hideRecommend?: boolean
  /** 左侧列表是否有数据，用于占位文案判断 */
  hasListData?: boolean
  /** 左侧列表正在加载中（用于详情区同步显示加载状态） */
  listLoading?: boolean
}





// ─── 繁体支持 ─────────────────────────────────────────────────────────────────
const route = useRoute()
const lang = (route.query['Accept-Language'] as string) || 'zh-Hans'
const isTraditional = computed(() => lang === 'zh-Hant')
const isGuangTheme = computed(() => (route.query.isGuangTheme as string) == '1')

/** 广告埋点 page_title：isGuangTheme=1 弹窗详情，否则内嵌详情 */
const advertPageTitle = computed(() =>
  isGuangTheme.value ? 'box_Inforfd_assembly' : 'new_Inforfd_assembly'
)

function tran(text: string): string {
  if (!text) return text
  if (isTraditional.value) return (text as any).tran()
  return text
}

// ─── 字体大小 ─────────────────────────────────────────────────────────────────
const fontSizes = [
  { label: '适中', titleSize: 32, bodySize: 18 },
  { label: '大',   titleSize: 36, bodySize: 22 },
  { label: '特大', titleSize: 40, bodySize: 24 },
]
const fontSize = ref<{ titleSize: number; bodySize: number }>(fontSizes[0])

// ─── 行情订阅（详情页股票） ───────────────────────────────────────────────────
const hkDelay = (route.query.HKDELAY as string) === '1'
const usDelay = (route.query.USDELAY as string) === '1'
// 涨跌色偏好：'1' = 绿涨红跌，其他 = 红涨绿跌
const preferGreenUp = route.query.preferGreenUptrendRedDowntrend as string | undefined
// 沪深权限：HS=1 有权限，HS=0 无权限
const hsPermission = (route.query.HS as string) !== '0'

// ─── 沪深权限弹窗 ─────────────────────────────────────────────────────────────
const showHsModal = ref(false)

function isHuShenMarket(market: string): boolean {
  const m = market.toUpperCase()
  return m === 'SH' || m === 'SZ' || m === 'SHSE' || m === 'SZSE'
}

function checkHsAndJump(fullCode: string): void {
  const dotIdx = fullCode.lastIndexOf('.')
  const market = dotIdx > -1 ? fullCode.slice(dotIdx + 1) : ''
  if (isHuShenMarket(market) && !hsPermission) {
    showHsModal.value = true
    return
  }
  jumpToStockChart(fullCode)
}

function onOpenAccount(): void {
  const isTest = window.location.hostname.includes('test') || window.location.hostname.includes('localhost')
  const url = isTest
    ? 'https://test-fdh5.eprobex.com/fdr/index.html#/initpage'
    : 'https://fdh5.eprobex.com/fdr/index.html#/initpage'
  // 嵌入客户端，调用原生接口打开系统默认浏览器
  window.open(`gw://funccall?funcname=OnOpenBrowser;params=${encodeURIComponent(url)}`)
  showHsModal.value = false
}

// 当前详情订阅的 key（detail 接口 stock[0]）
const DETAIL_STOCK_KEY = 'newsdetail_stock'

// 当前已订阅的 detail stock symbol，用于判断是否需要重新订阅
let currentDetailStockKey = ''

function resolveMarketLocal(market: string): string {
  return resolveMarket(market, hkDelay, usDelay)
}

/**
 * 订阅详情页 stock[0]（来自 detail 接口）
 */
function subscribeDetailStock(stockList: StockItem[]) {
  if (!stockList?.length) return

  const items = stockList
    .filter(s => s?.symbol && s?.market)
    .map(s => ({ symbol: s.symbol, market: resolveMarketLocal(s.market!) }))

  if (!items.length) return

  const key = items.map(i => `${i.symbol}_${i.market}`).join(',')
  if (key === currentDetailStockKey) return

  if (currentDetailStockKey) {
    ws.websocket.safeUnsubscribeList(DETAIL_STOCK_KEY)
  }
  currentDetailStockKey = key

  console.log(`[NewsDetail] 订阅详情股票:`, items)
  ws.websocket.safeSubscribeList(DETAIL_STOCK_KEY, items)
}

/**
 * 处理 onHQLIST 推送，更新详情页 stock 的涨跌幅
 */
function onDetailHqUpdate(msg: any) {
  const dynaData: any[] = msg?.QuoteData?.DynaData || []
  console.log('[NewsDetail] onHQLIST 推送数据:', dynaData)

  dynaData.forEach((d: any) => {
    if (d.UpdownRate === undefined && d.Updown === undefined) return

    // 更新详情页 stock[]
    if (detail.value?.stock?.length) {
      detail.value.stock.forEach((s: StockItem) => {
        if (s.symbol === d.InstrumentID) {
          if (d.UpdownRate !== undefined) {
            s.fluctuation_range = parseFloat((d.UpdownRate * 100).toFixed(2))
          }
          if (d.LastPrice !== undefined) {
            s.lastPrice = d.LastPrice
          }
          console.log(`[NewsDetail] 更新详情股票 ${s.symbol} fluctuation_range=${s.fluctuation_range}`)
        }
      })
    }
  })
}

onMounted(() => {
  ws.websocket.on('onHQLIST', onDetailHqUpdate)
})

onUnmounted(() => {
  ws.websocket.removeListener('onHQLIST', onDetailHqUpdate)
  ws.websocket.safeUnsubscribeList(DETAIL_STOCK_KEY)
  currentDetailStockKey = ''
  stopAdvertTimer()
  console.log('[NewsDetail] 已取消详情股票订阅')
})

// ─── 详情数据 ─────────────────────────────────────────────────────────────────
const detail = ref<DetailData | null>(null)
const loading = ref(true)
const errorMsg = ref('')  // 接口返回的错误信息

// ─── 音频/视频播放器 ──────────────────────────────────────────────────────────
const audioRef = ref<HTMLAudioElement | null>(null)
const videoRef = ref<HTMLVideoElement | null>(null)
const audioDuration = ref('0m0s')
const audioDurationSec = ref(0)
const audioCurrentTime = ref(0)
const videoDuration = ref('0m0s')
const audioPlaying = ref(false)
const videoPlaying = ref(false)

function formatDuration(seconds: number): string {
  if (!seconds || isNaN(seconds)) return '0m0s'
  const m = Math.floor(seconds / 60)
  const s = Math.floor(seconds % 60)
  return `${m}m${s}s`
}

function onAudioLoaded() {
  if (audioRef.value) {
    audioDurationSec.value = audioRef.value.duration
    audioDuration.value = formatDuration(audioRef.value.duration)
  }
}

function onVideoLoaded() {
  if (videoRef.value) {
    videoDuration.value = formatDuration(videoRef.value.duration)
  }
}

function toggleAudio() {
  if (!audioRef.value) return
  if (audioRef.value.paused) {
    audioRef.value.play()
  } else {
    audioRef.value.pause()
  }
}

function onTimeUpdate() {
  if (audioRef.value) {
    audioCurrentTime.value = audioRef.value.currentTime
  }
}

function onSeek(e: Event) {
  const target = e.target as HTMLInputElement
  if (audioRef.value) {
    audioRef.value.currentTime = parseFloat(target.value)
  }
}

function onAudioEnded() {
  audioPlaying.value = false
  audioCurrentTime.value = 0
}

function toggleVideo() {
  if (!videoRef.value) return
  if (videoRef.value.paused) {
    videoRef.value.play()
  } else {
    videoRef.value.pause()
  }
}

// ─── 广告位 ───────────────────────────────────────────────────────────────────
const advertList = ref<AdvertItem[]>([])
/** 展平后的轮播数组，直接用于模板渲染 */
const slideList = ref<AdvertSlide[]>([])
const advertIndex = ref(0)
let advertTimer: ReturnType<typeof setInterval> | null = null
/** 已曝光埋点的轮播项，同一素材轮播回来不再重复上报 */
const advertExposedKeys = new Set<string>()

function getAdvertSlideKey(slide: AdvertSlide, index: number): string {
  return `${slide.adCode}_${slide.sourceId}_${index}`
}

function reportAdvertSlideExposure(index: number) {
  const slide = slideList.value[index]
  if (!slide) return
  const key = getAdvertSlideKey(slide, index)
  if (advertExposedKeys.has(key)) return
  advertExposedKeys.add(key)
  reportAdvertExposure(advertPageTitle.value, slide)
}

/** 根据主题和语言从 materialInfo 中取正确的图片 */
function resolveAdvertImg(info: AdvertMaterialInfo): string {
  // isGuangTheme=1 时广告位单独读 URL theme，不影响页面其他区域
  const adIsDark = isGuangTheme.value
    ? (route.query.theme as string) === 'dark'
    : props.isDark
  if (isTraditional.value) {
    return (adIsDark ? info.tradBlack : info.tradWhite) || ''
  }
  return (adIsDark ? info.simpleBlack : info.simpleWhite) || ''
}

/** 将所有 ad 的 materialInfos 展平为轮播数组 */
function buildSlideList(list: AdvertItem[]): AdvertSlide[] {
  const slides: AdvertSlide[] = []
  for (const ad of list) {
    const adCode = ad.adCode || ad.adcode || ''
    const sourceId = ad.sourceId || ''
    const popupFrequency = getAdvertPopupFrequency(ad)
    for (const info of ad.materialInfos || []) {
      const img = resolveAdvertImg(info)
      const link = resolveAdvertJumpLink(info)
      if (img) slides.push({ img, link, adCode, sourceId, popupFrequency })
    }
  }
  return slides
}

function onAdvertClick(slide: AdvertSlide) {
  if (!slide.link) return
  reportAdvertClick(advertPageTitle.value, slide)
  window.open(slide.link)
}

function startAdvertTimer() {
  stopAdvertTimer()
  if (slideList.value.length <= 1) return
  advertTimer = setInterval(() => {
    advertIndex.value = (advertIndex.value + 1) % slideList.value.length
  }, 4000)
}

function stopAdvertTimer() {
  if (advertTimer) {
    clearInterval(advertTimer)
    advertTimer = null
  }
}

async function fetchAdvert(): Promise<void> {
  try {
    const res: any = await infoApi.getAdvertPage({
      data: { pageNum: 1, pageSize: 10 },
      params: { adType: 4, positionType: 91 },
      headers: buildHeaders(),
    })
    const list: AdvertItem[] = res?.data?.data || []
    advertList.value = list
    slideList.value = buildSlideList(list)
    advertExposedKeys.clear()
    advertIndex.value = 0
    reportAdvertSlideExposure(0)
    startAdvertTimer()
  } catch (e) {
    console.error('[NewsDetail] fetchAdvert error', e)
    advertList.value = []
    slideList.value = []
  }
}

watch(
  () => [
    isGuangTheme.value ? route.query.theme : props.isDark,
    isTraditional.value,
    isGuangTheme.value,
  ] as const,
  () => {
    if (advertList.value.length) {
      slideList.value = buildSlideList(advertList.value)
      advertExposedKeys.clear()
      advertIndex.value = 0
      reportAdvertSlideExposure(0)
      startAdvertTimer()
    }
  }
)

// 轮播切换时上报当前可见广告曝光，已曝光过的不再重复上报
watch(advertIndex, (idx) => {
  reportAdvertSlideExposure(idx)
})

// ─── 推荐资讯 ─────────────────────────────────────────────────────────────────
const recommendList = ref<RecommendItem[]>([])
const recommendLoading = ref(false)

async function fetchRecommend(newsId: number | string): Promise<void> {
  recommendLoading.value = true
  recommendList.value = []
  try {
    const res: any = await infoApi.getRecommendDetail({
      data: { newsId },
      headers: buildHeaders(),
    })
    if (Array.isArray(res?.data) && res.data.length > 0) {
      recommendList.value = res.data
    } else {
      recommendList.value = []
    }
  } catch (e) {
    console.error('[NewsDetail] fetchRecommend error', e)
    recommendList.value = []
  } finally {
    recommendLoading.value = false
  }
}

function buildHeaders() {
  return {
    'Content-Type': 'application/json',
    clientType: 'h5',
    'Accept-Language': lang,
  }
}

async function fetchDetail(newsId: number | string) {
  loading.value = true
  detail.value = null
  errorMsg.value = ''
  try {
    const res: any = await infoApi.getNewsDetail({
      data: { newsId: String(newsId) },
      headers: buildHeaders(),
    })
    // 优先显示 message，其次判断 code === 20001
    if (!res?.data) {
      errorMsg.value = res?.message || (res?.code === 20001 ? tran('文章不存在') : tran('暂无内容'))
      return
    }
    const raw = res.data
    detail.value = isTraditional.value && raw ? objTran('t', raw) : raw

    // 订阅详情页 stock[0] 的行情
    if (detail.value?.stock?.length) {
      subscribeDetailStock(detail.value.stock)
    }
  } catch (e) {
    console.error('[NewsDetail] fetchDetail error', e)
    errorMsg.value = tran('加载失败，请稍后重试')
  } finally {
    loading.value = false
  }
}
// 同时监听 newsId 和 newsDecryptId，合并为一个 watch 避免重复请求
watch(
  () => [props.newsId, props.newsDecryptId] as [typeof props.newsId, typeof props.newsDecryptId],
  (newVal, oldVal) => {
    const [id, decryptId] = newVal
    const [oldId, oldDecryptId] = oldVal ?? [null, null]
    if (id !== null && id !== undefined) {
      // 详情接口用 decryptId（优先），推荐接口用 newsId
      const detailId = decryptId || id
      // newsId 变化时同时刷新详情和推荐；仅 decryptId 变化时只刷新详情
      if (id !== oldId) {
        fetchDetail(detailId)
        fetchRecommend(id)
        fetchAdvert()
      } else if (decryptId !== oldDecryptId) {
        fetchDetail(detailId)
      }
    } else {
      detail.value = null
      errorMsg.value = ''
      if (!props.listLoading) loading.value = false
      recommendList.value = []
    }
  },
  { immediate: true }
)

// ─── 股票代码高亮 + 音频处理 ──────────────────────────────────────────────────
/**
 * 处理正文 HTML：
 *   1. 将 <a data-symbol data-market>$...$</a> 转为可点击 span（仅 $...$ 包裹的才处理）
 *   2. 将纯文本中的 $名称(代码)$ 转为可点击 span
 *   3. 处理音频：显示隐藏的 <audio> 标签，隐藏 135editor 自定义播放 UI
 */
function highlightStock(content: string, color = '#4F72C6'): string {
  if (!content) return ''

  // ── 1. 处理 <a data-symbol data-market>$...$</a> ──────────────────────────
  content = content.replace(
    /<a\s[^>]*?data-symbol="([^"]+)"[^>]*?data-market="([^"]+)"[^>]*?>\s*\$([^$]+)\$\s*<\/a>/gi,
    (_match: string, symbol: string, market: string, inner: string) => {
      const displayText = inner.trim()
      const fullCode = `${symbol}.${market}`
      return `<span style="color:${color};font-weight:500;cursor:pointer" data-stock-code="${fullCode}" data-stock-name="${displayText}">${displayText}</span>`
    }
  )

  // ── 2. 处理纯文本中的 $名称(代码)$ ──────────────────────────────────────────
  const MARKET_SUFFIX = '(?:HK|SH|SZ|US|NYSE|NASDAQ|HKSE|AMEX|BJ)'
  const CODE_PATTERN = `(?:\\d{4,6}|[A-Z]{1,6})\\.${MARKET_SUFFIX}`
  const DOLLAR_REG = new RegExp(
    `\\$([\\u4e00-\\u9fa5a-zA-Z0-9·]{1,12})\\((${CODE_PATTERN})\\)\\$`,
    'g'
  )

  content = content.replace(/>([^<>]+)</g, (_fullMatch: string, textContent: string) => {
    const highlighted = textContent.replace(
      DOLLAR_REG,
      (_m: string, name: string, code: string) =>
        `<span style="color:${color};font-weight:500;cursor:pointer" data-stock-code="${code.trim()}" data-stock-name="${name.trim()}">${name}(${code})</span>`
    )
    return `>${highlighted}<`
  })

  // ── 3. 处理音频 ───────────────────────────────────────────────────────────
  // 显示隐藏的 <audio> 标签并添加 controls
  content = content.replace(/<audio([^>]*?)>/gi, (_match: string, attrs: string) => {
    attrs = attrs.replace(/style="[^"]*"/gi, (styleMatch: string) => {
      let style = styleMatch
        .replace(/display\s*:\s*none\s*;?/gi, '')
        .replace(/width\s*:\s*0\s*;?/gi, '')
        .replace(/height\s*:\s*0\s*;?/gi, '')
      style = style.replace(/style="/i, 'style="display:block;width:100%;margin:12px 0;')
      return style
    })
    if (!/controls/i.test(attrs)) attrs += ' controls'
    return `<audio${attrs}>`
  })

  // ── 4. 修复图片无效 width 样式 + 防盗链 ─────────────────────────────────
  // 135editor 导出的图片 style 里含 width:"auto"（带引号），是非法 CSS 导致图片不显示
  // 将 width:"auto" / width:&quot;auto&quot; 替换为 width:auto，并补 max-width:100%
  // 同时加 referrerpolicy="no-referrer" 绕过防盗链
  content = content.replace(/<img([^>]*?)>/gi, (_match: string, attrs: string) => {
    // 先解码 &quot; 实体
    attrs = attrs.replace(/&quot;/gi, '"')
    // 去掉 style 里的 width:"xxx" 带引号写法，改为合法值
    attrs = attrs.replace(
      /(\bwidth\s*:\s*)"([^"]*?)"/gi,
      (_m: string, _prefix: string, val: string) => `width:${val || 'auto'}`
    )
    // 确保图片有 max-width:100% 防止溢出
    if (/style="/i.test(attrs)) {
      attrs = attrs.replace(/style="/i, 'style="max-width:100%;height:auto;')
    } else {
      attrs += ' style="max-width:100%;height:auto;"'
    }
    // 加 referrerpolicy="no-referrer" 绕过防盗链（135editor 等图床）
    if (!/referrerpolicy/i.test(attrs)) {
      attrs += ' referrerpolicy="no-referrer"'
    }
    return `<img${attrs}>`
  })

  // 隐藏 135editor 自定义音频 UI
  content = content.replace(
    /(<section[^>]*class="[^"]*share_audio_context[^"]*"[^>]*?)style="([^"]*)"/gi,
    (_match: string, before: string, style: string) => `${before}style="${style};display:none"`
  )

  return content
}
// 事件委托：点击正文中的股票 span
function onBodyClick(e: MouseEvent) {
  const target = e.target as HTMLElement
  const span = target.closest('[data-stock-code]') as HTMLElement | null
  if (!span) return
  const code = span.dataset.stockCode
  if (!code) return
  checkHsAndJump(code)
}

// 点击详情页股票卡片跳转分时图
function onStockCardClick(s: StockItem) {
  if (!s.market) return
  const fullCode = `${s.symbol}.${s.market}`
  checkHsAndJump(fullCode)
}

 
// 判断股票是否显示延时图标
function isDelayedStock(s: StockItem): boolean {
  const market = (s.market ?? s.exchange ?? '').toUpperCase()
  if (!market) return false
  const region = getFDMarketRegion(market)
  if (region === 'HK' && hkDelay) return true
  if (region === 'US' && usDelay) return true
  return false
}

// ─── 工具函数 ─────────────────────────────────────────────────────────────────
/**
 * 相对时间：X分钟前 / X小时前 / 昨天 HH:mm / YYYY-MM-DD HH:mm
 */
// function formatRelativeTime(val: string | number | undefined): string {
//   if (!val) return ''
//   const d = typeof val === 'number'
//     ? new Date(val > 1e10 ? val : val * 1000)
//     : new Date(val)
//   if (isNaN(d.getTime())) return String(val)

//   const now = Date.now()
//   const diff = now - d.getTime()
//   const minutes = Math.floor(diff / 60000)
//   const hours = Math.floor(diff / 3600000)

//   if (minutes < 1) return tran('刚刚')
//   if (minutes < 60) return `${minutes}${tran('分钟前')}`
//   if (hours < 24) return `${hours}${tran('小时前')}`

//   // 判断是否是昨天
//   const today = new Date()
//   const yesterday = new Date(today)
//   yesterday.setDate(today.getDate() - 1)
//   const pad = (n: number) => String(n).padStart(2, '0')
//   if (
//     d.getFullYear() === yesterday.getFullYear() &&
//     d.getMonth() === yesterday.getMonth() &&
//     d.getDate() === yesterday.getDate()
//   ) {
//     return `${tran('昨天')} ${pad(d.getHours())}:${pad(d.getMinutes())}`
//   }

//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
// }

function formatRelativeTime(val: string | number | undefined): string {
  if (!val) return ''
  const d = typeof val === 'number'
    ? new Date(val > 1e10 ? val : val * 1000)
    : new Date(val)
  if (isNaN(d.getTime())) return String(val)
  const pad = (n: number) => String(n).padStart(2, '0')
  const now = new Date()
  const isToday =
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate()
  const time = `${pad(d.getHours())}:${pad(d.getMinutes())}`
  if (isToday) return `今天 ${time}`
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${time}`
}

function formatPct(val: number | undefined): string {
  if (val === undefined || val === null) return ''
  const sign = val < 0 ? '' : '+'
  return `${sign}${val.toFixed(2)}%`
}

function stockClass(val: number | undefined): string {
  return getStockClass(val, preferGreenUp)
}

function onSelectNews(id: number, title: string, decryptId: string) {
  openNewsWindow(id, title, decryptId)
  // emit('select-news', id)
}

return (_ctx: any,_cache: any) => {
  const _directive_widthoverflowtitle = _resolveDirective("widthoverflowtitle")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["news-detail", __props.isDark ? 'dark' : 'light'])
  }, [
    (loading.value || (props.listLoading && !detail.value))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(tran('加载中')) + "…", 1))
      : (detail.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, _toDisplayString(tran('字体')) + "：", 1),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fontSizes, (size) => {
                return _createElementVNode("span", {
                  key: size.label,
                  class: _normalizeClass(["detail-font-btn", { active: fontSize.value.titleSize === size.titleSize }]),
                  onClick: ($event: any) => (fontSize.value = size)
                }, _toDisplayString(tran(size.label)), 11, _hoisted_6)
              }), 64))
            ]),
            _createElementVNode("h2", {
              class: "detail-title",
              style: _normalizeStyle({ fontSize: fontSize.value.titleSize + 'px' })
            }, _toDisplayString(tran(detail.value.title)), 5),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(tran('文章来源')), 1),
              _createElementVNode("span", _hoisted_9, [
                (detail.value.avator)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "detail-source-avatar",
                      src: detail.value.avator,
                      alt: ""
                    }, null, 8, _hoisted_10))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(tran(detail.value.category || detail.value.sourceName || '')), 1)
              ]),
              _createElementVNode("span", _hoisted_11, _toDisplayString(formatRelativeTime(detail.value.createTime|| detail.value.publishTime)), 1),
              (detail.value.audioUrl)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (!audioPlaying.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(audioDuration.value), 1),
                          _createElementVNode("button", {
                            class: "audio-inline__btn",
                            onClick: toggleAudio
                          }, _hoisted_15)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("input", {
                            class: "audio-inline__progress",
                            type: "range",
                            min: "0",
                            max: audioDurationSec.value,
                            step: "0.1",
                            value: audioCurrentTime.value,
                            onInput: onSeek
                          }, null, 40, _hoisted_16),
                          _createElementVNode("button", {
                            class: "audio-inline__btn",
                            onClick: toggleAudio
                          }, _hoisted_18)
                        ], 64))
                  ]))
                : _createCommentVNode("", true),
              (detail.value.audioUrl)
                ? (_openBlock(), _createElementBlock("audio", {
                    key: 1,
                    ref_key: "audioRef",
                    ref: audioRef,
                    src: detail.value.audioUrl,
                    preload: "metadata",
                    onLoadedmetadata: onAudioLoaded,
                    onPlay: _cache[0] || (_cache[0] = ($event: any) => (audioPlaying.value = true)),
                    onPause: _cache[1] || (_cache[1] = ($event: any) => (audioPlaying.value = false)),
                    onEnded: onAudioEnded,
                    onTimeupdate: onTimeUpdate
                  }, null, 40, _hoisted_19))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["detail-content-area", { 'is-locked': detail.value.isPermission === 0 }])
            }, [
              (detail.value.stock && detail.value.stock.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.stock, (s) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: s.symbol || s.id,
                        class: "detail-stock-card",
                        onDblclick: ($event: any) => (onStockCardClick(s))
                      }, [
                        _createElementVNode("span", _hoisted_22, [
                          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_23, [
                            _createTextVNode(_toDisplayString(tran(s.name || s.symbol || '')) + _toDisplayString(s.symbol && s.name ? `(${s.symbol})` : ''), 1)
                          ])), [
                            [_directive_widthoverflowtitle, tran(s.name || s.symbol || '') + (s.symbol && s.name ? `(${s.symbol})` : '')]
                          ]),
                          (isDelayedStock(s))
                            ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", {
                          class: _normalizeClass(["stock-card__pct", stockClass(s.fluctuation_range)])
                        }, _toDisplayString(formatPct(s.fluctuation_range)), 3)
                      ], 40, _hoisted_21))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (detail.value.videoUrl)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("video", {
                      ref_key: "videoRef",
                      ref: videoRef,
                      src: detail.value.videoUrl,
                      controls: "",
                      preload: "metadata"
                    }, null, 8, _hoisted_26)
                  ]))
                : _createCommentVNode("", true),
              (detail.value.abstracts && detail.value.content)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "detail-stocks detail-abstracts",
                    style: _normalizeStyle({ fontSize: fontSize.value.bodySize + 'px' })
                  }, _toDisplayString(tran(detail.value.abstracts)), 5))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", {
                  class: "detail-body",
                  style: _normalizeStyle({ fontSize: fontSize.value.bodySize + 'px' }),
                  innerHTML: highlightStock(tran(detail.value.content || detail.value.abstracts || '')),
                  onClick: onBodyClick
                }, null, 12, _hoisted_28)
              ]),
              (detail.value.isPermission === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("p", _hoisted_31, _toDisplayString(tran('该栏目是注册用户及以上专享')), 1),
                      _createElementVNode("button", {
                        class: "detail-permission-btn",
                        onClick: onOpenAccount
                      }, _toDisplayString(tran('立即开户')), 1),
                      _createElementVNode("p", _hoisted_32, _toDisplayString(tran('联系客户经理')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            (slideList.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", {
                    class: "news-advert-slide",
                    style: _normalizeStyle({ transform: `translateX(-${advertIndex.value * 100}%)` })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slideList.value, (slide, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: idx,
                        class: "news-advert-item",
                        onClick: ($event: any) => (onAdvertClick(slide))
                      }, [
                        _createElementVNode("img", {
                          src: slide.img,
                          class: "news-advert-img",
                          alt: "",
                          referrerpolicy: "no-referrer"
                        }, null, 8, _hoisted_35)
                      ], 8, _hoisted_34))
                    }), 128))
                  ], 4),
                  (slideList.value.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slideList.value, (_, idx) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: idx,
                            class: _normalizeClass(["news-advert-dot", { active: idx === advertIndex.value }]),
                            onClick: _withModifiers(($event: any) => (advertIndex.value = idx), ["stop"])
                          }, null, 10, _hoisted_37))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!props.hideRecommend && (recommendList.value.length || recommendLoading.value))
              ? (_openBlock(), _createBlock(RecommendList, {
                  key: 1,
                  list: recommendList.value,
                  "is-dark": __props.isDark,
                  loading: recommendLoading.value,
                  lang: _unref(lang),
                  "prefer-green-up": _unref(preferGreenUp),
                  "hk-delay": hkDelay,
                  "us-delay": usDelay,
                  onSelectNews: onSelectNews,
                  onStockDblclick: checkHsAndJump
                }, null, 8, ["list", "is-dark", "loading", "lang", "prefer-green-up"]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_38, [
            (errorMsg.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(errorMsg.value), 1)
                ], 64))
              : (props.hasListData)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(tran('请选择左侧文章查看详情')), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(tran('暂无数据')), 1)
                  ], 64))
          ])),
    (detail.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(tran('风险提示：本页面涉及的任何内容及操作均来源于第三方，与本平台无关，仅供您参考与学习观摩，该等内容不构成投资建议或投资购买的邀约，不得作为您做出任何投资的依据，您应自主投资决策，自行承担投资风险与损失，投资有风险，入市须谨慎！')), 1))
      : _createCommentVNode("", true),
    (showHsModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "hs-modal-mask",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showHsModal.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("button", {
              class: "hs-modal__close",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showHsModal.value = false))
            }, "✕"),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("span", _hoisted_42, _toDisplayString(tran('温馨提示')), 1)
            ]),
            _createElementVNode("p", _hoisted_43, _toDisplayString(tran('应监管要求，陆股通行情仅向已开通环球账户的客户开放。')), 1),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("button", {
                class: "hs-modal__open-btn",
                onClick: onOpenAccount
              }, _toDisplayString(tran('立即开户')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})